import {
  Component,
  ViewEncapsulation,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { ReservationPage } from 'src/pages/reservation/reservation';
import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Util } from 'src/shared/util/util';

@Component({
    templateUrl: 'reservations-of-day.html',
    styleUrls: ['./reservations-of-day.scss'],
    selector: 'tidy-reservations-of-day',
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('slideAnimation', [
            state('collapsed', style({
                height: '0px',
                overflow: 'hidden',
                opacity: '0'
            })),
            state('expanded', style({
                height: '*',
                overflow: 'visible',
                opacity: '1'
            })),
            transition('collapsed <=> expanded', [
                animate('300ms ease-in-out')
            ])
        ])
    ],
    standalone: false
})
export class ReservationsOfDayPage implements OnChanges, OnInit {
  isRightSideContent = true;
  dialogParams: any;
  propertiesWithEvents: any;
  pageTitle: string;
  expandedSourceData: { [key: string]: boolean } = {};

  constructor(
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
    public util: Util
  ) {}

  ngOnChanges(_changes: SimpleChanges) {
    // No changes to process
  }

  async ngOnInit() {
    this.isRightSideContent =
      (await this.storage.retrieve('dialog-right-side-open')) || false;
    this.dialogParams = await this.storage.retrieve('dialog-params');
    const _language = localStorage.getItem('language');
    this.propertiesWithEvents = this.dialogParams.propertiesWithEvents.filter(
      (property) =>
        property?.items?.length > 0 &&
        property?.items?.some((item) => !item?.booking)
    );
    this.addCheckInCheckOutBoolean();
    const parsedDate = new ParseDateTimePipe().transform(this.dialogParams.day.fullDate, 'ddd MMM d');
    this.pageTitle = `${new TranslationPipe().transform('Reservations')   } - ${parsedDate}`;
    this.rightSidePanelService.setDialogPageTitle(this.pageTitle);
  }

  addCheckInCheckOutBoolean() {
    this.propertiesWithEvents.map((property) => {
      property.items.map((item) => {
        const isReservaiton = item?.checkInTime;
        if (isReservaiton) {
          if (item.startDate === this.dialogParams.day.fullDate) {
            item['isCheckIn'] = true;
          } else {
            item['isCheckIn'] = false;
          }
        }
      });
    });
  }

  goToReservation(reservation: any) {
    const addressName =
      reservation?.address?.address_name ||
      reservation?.address?.address1 +
        (reservation?.address?.address2
          ? ` ${  reservation?.address?.address2}`
          : '');
    const guestReservation = {
      ...reservation,
      check_in_date: reservation?.object?.check_in_date,
      check_out_date: reservation?.object?.check_out_date,
      check_in_time: reservation?.object?.check_in_time,
      check_out_time: reservation?.object?.check_out_time,
    };
    const params = {
      guestReservation,
      address: addressName,
    };
    this.rightSidePanelService.navigateTo(
      'reservation',
      params,
      ReservationPage
    );
  }

  toggleSourceData(itemId: string) {
    this.expandedSourceData[itemId] = !this.expandedSourceData[itemId];
  }

  isSourceDataExpanded(itemId: string): boolean {
    return this.expandedSourceData[itemId] || false;
  }
}
